module.exports = __webpack_public_path__ + "media/images/city/003-mole-antonelliana-751ff7a0f7ae3dbefc3934a8bb1f057b.svg";